// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import { Typography } from "@mui/material";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";

function DataTableHeadCell({
  width,
  cellWidth,
  children,
  sorted,
  align,
  ...rest
}) {
  return (
    <ArgonBox
      component="th"
      width={width}
      py={1.5}
      px={cellWidth ? 1 : 3}
      sx={({ borders: { borderWidth, borderColor } }) => ({
        borderBottom: `${borderWidth[1]} solid ${borderColor}`,
      })}
    >
      <ArgonBox
        {...rest}
        position="relative"
        textAlign={align}
        color="black"
        opacity={0.7}
      >
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: "bold",
            color: "#8392AB",
            textTransform: "none",
          }}
        >
          {children}
        </Typography>
      </ArgonBox>
    </ArgonBox>
  );
}

// Setting default values for the props of DataTableHeadCell
DataTableHeadCell.defaultProps = {
  width: "auto",
  sorted: "none",
  align: "left",
};

// Typechecking props for the DataTableHeadCell
DataTableHeadCell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  sorted: PropTypes.oneOf([false, "none", "asce", "desc"]),
  align: PropTypes.oneOf(["left", "right", "center"]),
  cellWidth: PropTypes.bool,
};

export default DataTableHeadCell;
